import { render, staticRenderFns } from "./CourseCategoryTable.vue?vue&type=template&id=3a42491e&scoped=true"
import script from "./CourseCategoryTable.vue?vue&type=script&lang=js"
export * from "./CourseCategoryTable.vue?vue&type=script&lang=js"
import style0 from "./CourseCategoryTable.vue?vue&type=style&index=0&id=3a42491e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a42491e",
  null
  
)

export default component.exports